import React, { useState, useEffect } from "react";
import history from "../../../../../../utils/history";
import BackNavigationPanel from "../../../../../ui/back-navigation-panel/BackNavigationPanel";
import MenuTable from "../../../../../ui/menu-table/MenuTable";
import { EmailTypes, UpdateEmailNotificationStatusRequest, UpdateEmailNotificationStatusResponse } from "../../../../../../utils/grpc/generated/Billsby.Protos/Messenger/private/companyconfig/companyconfig_pb";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../..";
import { IEmailRoutingReducerState } from "../../../../../../reducers/emailRoutingReducer";
import { IAuthReducerState } from "../../../../../../reducers/authReducer";
import { updateEmailNotificationToggles, fetchEmailNotificationToggles } from "../../../../../../actions/emailRoutingActions";


const NewBillDateMenu: React.FC = () => {
  const dispatch = useDispatch();
  const { currentCompanyId } = useSelector<AppState, IAuthReducerState>(state => state.auth);
  const { emailNotificationToggles } = useSelector<AppState, IEmailRoutingReducerState>(state => state.emailRoutingReducer);

  const [switchState, setSwitchState] = useState({
    nextBillDateIsChanged: false
  });

  const updateData = async (updateEmailNotification: UpdateEmailNotificationStatusRequest) => {
    try {
      await (dispatch(updateEmailNotificationToggles(updateEmailNotification) as any) as { response: UpdateEmailNotificationStatusResponse });
      dispatch(fetchEmailNotificationToggles(Number(currentCompanyId)));
    }
    catch (err) { }
  }

  useEffect(() => {
    if (emailNotificationToggles.getEmailNotificationConfigsList().length) {
      let newState: any = {};
      emailNotificationToggles.getEmailNotificationConfigsList().forEach((elem) => {
        switch (elem.getEmailType()) {
          case EmailTypes.SUBSCRIPTION_BILL_DATE_CHANGED:
            newState.nextBillDateIsChanged = elem.getIsEnabled();
            break;
          default:
            break;
        }
      })
      setSwitchState(newState);
    }
  }, [emailNotificationToggles]);

  useEffect(() => {
    dispatch(fetchEmailNotificationToggles(Number(currentCompanyId)));
  }, []);


  return (
    <div>
      <BackNavigationPanel
        title={"EMAIL_TEMPLATE_NEW_BILL_DATE_TITLE"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/email-notifications/emails")}>
        <MenuTable
          data={[
            {
              title: "EMAIL_TEMPLATE_NEW_BILL_DATE_NEXT_BILL_DATE_IS_CHANGED_TEMPLATE",
              onClick: () => history.push("/configuration/email-notifications/emails/new-bill-date/next-bill-date-is-changed-template"),
              canConfigureNotification: true,
              enableNotification: switchState.nextBillDateIsChanged,
              enableNotificationChange: (isChecked) => {
                setSwitchState({ ...switchState, nextBillDateIsChanged: isChecked });
                const updateEmailNotification = new UpdateEmailNotificationStatusRequest();
                updateEmailNotification.setCompanyId(Number(currentCompanyId));
                updateEmailNotification.setEmailType(EmailTypes.SUBSCRIPTION_BILL_DATE_CHANGED);
                updateEmailNotification.setIsEnabled(isChecked);
                updateData(updateEmailNotification);
              }
            }
          ]}
        />
      </BackNavigationPanel>
    </div>
  )
}

export default NewBillDateMenu
